if (!customElements.get('paired-collection')) {
    customElements.define('paired-collection', class extends HTMLElement {
        connectedCallback() {
            this.track = this.querySelector('ul');
            this.controls = this.querySelector('.campos-paired__controls');
            this.motion = matchMedia('(prefers-reduced-motion: reduce)');
            this.events = new AbortController();
            const options = { signal: this.events.signal };
            this.originalItems = Array.from(this.track.children);
            this.setupProductDragging(options);
            this.paused = this.dataset.autoplay !== 'true';
            this.hovered = false;
            this.focused = false;
            this.touching = false;
            this.querySelectorAll('[data-direction]').forEach(button => {
                button.addEventListener('click', () => this.advance(Number(button.dataset.direction)), options);
            });
            this.addEventListener('pointerenter', event => { this.hovered = event.pointerType === 'mouse'; }, options);
            this.addEventListener('pointerleave', () => { this.hovered = false; }, options);
            this.addEventListener('focusin', () => { this.focused = true; }, options);
            this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); }, options);
            this.addEventListener('pointerdown', () => { this.touching = true; }, options);
            window.addEventListener('pointerup', () => { this.touching = false; }, options);
            window.addEventListener('pointercancel', () => { this.touching = false; }, options);
            this.observer = new ResizeObserver(() => this.setupLoop());
            this.track.addEventListener('scroll', () => {
                clearTimeout(this.scrollTimer);
                this.scrollTimer = setTimeout(() => this.normalizeLoop(), 150);
            }, { ...options, passive: true });
            this.observer.observe(this.track);
            const rotate = () => {
                const bounds = this.getBoundingClientRect();
                if (!this.motion.matches && !document.hidden && !this.hovered && !this.focused && !this.touching && bounds.bottom > 0 && bounds.top < innerHeight) {
                    if (!this.paused) this.advance(1);
                }
            };
            const interval = Number(this.dataset.interval) || 5000;
            const carousels = Array.from(document.querySelectorAll('paired-collection'));
            const phase = carousels.indexOf(this) * interval / Math.max(carousels.length, 1);
            this.startTimer = setTimeout(() => {
                rotate();
                this.timer = setInterval(rotate, interval);
            }, interval + phase);
        }

        setupProductDragging(options) {
            let pointerId;
            let startX;
            let lastX;
            let dragged = false;
            this.track.addEventListener('pointerdown', (event) => {
                dragged = false;
                if (event.pointerType !== 'mouse' || event.button !== 0 ||
                    event.target.closest('button, input, select, textarea, label, quick-view, compare-add-button')) return;
                pointerId = event.pointerId;
                startX = lastX = event.clientX;
            }, options);
            this.track.addEventListener('pointermove', (event) => {
                if (event.pointerId !== pointerId) return;
                if (!dragged && Math.abs(event.clientX - startX) < 6) return;
                if (!dragged) {
                    dragged = true;
                    this.track.setPointerCapture(pointerId);
                    this.track.classList.add('is-dragging');
                }
                event.preventDefault();
                this.track.scrollLeft += lastX - event.clientX;
                lastX = event.clientX;
            }, options);
            const endDrag = (event) => {
                if (event.pointerId !== pointerId) return;
                pointerId = undefined;
                this.track.classList.remove('is-dragging');
            };
            window.addEventListener('pointerup', endDrag, options);
            window.addEventListener('pointercancel', endDrag, options);
            this.track.addEventListener('lostpointercapture', endDrag, options);
            this.track.addEventListener('dragstart', (event) => {
                if (pointerId !== undefined) event.preventDefault();
            }, options);
            this.track.addEventListener('click', (event) => {
                if (!dragged || event.detail === 0) return;
                dragged = false;
                event.preventDefault();
                event.stopImmediatePropagation();
            }, { ...options, capture: true });
        }

        setupLoop() {
            const width = this.track.clientWidth;
            if (!width || width === this.loopWidth) return;
            this.loopWidth = width;
            this.track.querySelectorAll('[data-carousel-clone]').forEach(item => item.remove());
            this.loopSpan = 0;
            this.controls.hidden = this.track.scrollWidth <= width + 2;
            if (this.controls.hidden || this.originalItems.length < 2) return;
            const clone = item => {
                const copy = item.cloneNode(true);
                copy.dataset.carouselClone = '';
                copy.setAttribute('aria-hidden', 'true');
                copy.removeAttribute('id');
                copy.removeAttribute('data-shopify-editor-block');
                copy.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
                copy.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(node => node.setAttribute('tabindex', '-1'));
                return copy;
            };
            this.track.prepend(...this.originalItems.map(clone));
            this.track.append(...this.originalItems.map(clone));
            this.loopStart = this.originalItems[0].offsetLeft - this.track.firstElementChild.offsetLeft;
            this.loopSpan = this.originalItems.at(-1).nextElementSibling.offsetLeft - this.originalItems[0].offsetLeft;
            this.track.scrollTo({ left: this.loopStart, behavior: 'instant' });
        }

        normalizeLoop() {
            if (!this.loopSpan || this.track.contains(document.activeElement)) return;
            const position = this.track.scrollLeft;
            const start = this.loopStart;
            if (position < start - 1 || position >= start + this.loopSpan - 1) {
                const offset = ((position - start) % this.loopSpan + this.loopSpan) % this.loopSpan;
                this.track.scrollTo({ left: start + offset, behavior: 'instant' });
            }
        }

        advance(direction) {
            if (!this.loopSpan) return;
            this.normalizeLoop();
            const step = this.originalItems[1].offsetLeft - this.originalItems[0].offsetLeft;
            this.track.scrollTo({ left: this.track.scrollLeft + direction * step, behavior: this.motion.matches ? 'instant' : 'smooth' });
        }

        disconnectedCallback() {
            clearInterval(this.timer);
            clearTimeout(this.startTimer);
            clearTimeout(this.scrollTimer);
            this.track.querySelectorAll('[data-carousel-clone]').forEach(item => item.remove());
            this.loopWidth = 0;
            this.events.abort();
            this.observer.disconnect();
        }
    });
}
